import { useFiltersLists } from "features/filters/store/lists";
import { OcupacaoEnum } from "features/maps/enums";
import { useConcentracaoColheitaStore } from "features/filters/store/useConcentracaoColheitaStore";
import { useEffect } from "react";

function useConcentracaoColheitaOcupacoesFilters() {
  const {
    filters: { ocupacao },
    update,
    updateField,
  } = useConcentracaoColheitaStore();

  const { concentracaoColheita } = useFiltersLists();

  const onChange = (ocupacaoId: OcupacaoEnum) => {
    const findOcupacao = concentracaoColheita?.ocupacoes.find(
      (item) => item.codigo === ocupacaoId
    );

    update({
      ocupacao: findOcupacao?.codigo,
      tecnologias: findOcupacao?.tecnologias.map(item => item.id),
      concentracoes: [],
    });
  };

  useEffect(() => {
    let findOcupacao = concentracaoColheita?.ocupacoes.find(
      (item) => item.codigo === ocupacao && item.enabled
    );

    if (!findOcupacao) {
      findOcupacao = concentracaoColheita?.ocupacoes.find(
        (item) => item.enabled
      );
    }

    updateField("ocupacao", findOcupacao?.codigo);
  }, [ocupacao, concentracaoColheita?.ocupacoes, updateField]);

  return {
    value: ocupacao,
    items: concentracaoColheita?.ocupacoes ?? [],
    onChange,
  };
}

export default useConcentracaoColheitaOcupacoesFilters;
